import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BiotechIcon(props: IconProps) {
    return <Icon {...props} iconKey={"biotech"}/>
}
